import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Message } from 'semantic-ui-react';
import FormattedHTMLMessage from '@/components/FormattedHTMLMessage';
import subscriptionMessage from '../helper';
import DatasetSubscribeButton from './DatasetSubscribeButton';

const DatasetSubscribeMessage = ({
  event,
  name,
  onClick,
  saveStatus,
  subscribed,
}) => (
  <Message size="small" className="aridhia-dataset-subscribe-message">
    <Message.Content>
      <DatasetSubscribeButton onClick={onClick} subscribed={subscribed} saveStatus={saveStatus} />
      <Message.Header>
        <FormattedMessage id={subscriptionMessage(event, subscribed, 'header')} values={{ title: name }} />
        :
      </Message.Header>
      <FormattedHTMLMessage id={subscriptionMessage(event, subscribed)} values={{ title: name }} />
    </Message.Content>
  </Message>
);

export default DatasetSubscribeMessage;
